import type { SupportedLocale, TranslationLocale } from "@turo/urls";

const PRODUCTION_DOMAIN = "turo.com";
const isProductionDomain =
  typeof document !== "undefined" &&
  (document.location.hostname === PRODUCTION_DOMAIN ||
    document.location.hostname.endsWith(`.${PRODUCTION_DOMAIN}`));

const config = {
  /* cspell:disable */
  GOOGLE_CAPTCHA_SITE_KEY: isProductionDomain
    ? "6Lc_osgUAAAAAHrdC_7s0CsU5wWgwdLyI8HpNUom"
    : "6LfbeMgUAAAAAFzX_C3fHpJD-8WTMUvj8om2rkcN",
  /* cspell:enable */

  SOCURE_API_KEY: isProductionDomain
    ? "7e614dc3-e43d-4c6e-877a-7888bd4b9aa5"
    : "9c3e8d3e-fa7f-48c8-b9c4-f5e7d14f6442",

  LOCALE_TO_TRANSLATIONS_LOCALE: {
    en_AU: "en_US",
    en_CA: "en_US",
    en_GB: "en_US",
    en_US: "en_US",
    es_US: "es_US",
    fr_CA: "fr_CA",
    fr_FR: "fr_FR",
    pt_US: "pt_BR",
  } satisfies Record<SupportedLocale, TranslationLocale>,
  DEFAULT_LOCALE: "en_US",
} as const;

export default config;
